<svelte:options tag="sa-video-player" />

<script>
    /**
     * Wraps VideoPlayer so that it can be used as a web component.
     *
     * See README.md
     *
     * @component VideoPlayer
     */
    // Polyfills required for es2015
    __sa_polyfills__;
    import VideoPlayer from '../index.mjs';

    import { get_current_component } from 'svelte/internal';

    /**
     * Should be the videoObject in this format:
     * encodeURI(JSON.stringify(videoObject))
     * @type {string}
     */
    export let video;
    /**
     * Settings to configure the video playback / view / ananlytics
     * @type {Object}
     */
    export let settings = {};

    let selfWebComponent = get_current_component();
    let videoPlayer;
    let updateVideoTimeout;

    $: video && updateVideo();

    function updateVideo() {
        // Ensure we only have 1 active call to updateVideo (hopefully)
        clearTimeout(updateVideoTimeout);

        // !selfWebComponent.parentElement === Stupid hack for article_markdown_editor
        // React somehow triggers the mount before the element is
        // actually in the dom, so we need to wait for it to settle
        // If this is ever removed, might need to wait for onMount at least
        if (!selfWebComponent.parentElement) {
            updateVideoTimeout = setTimeout(updateVideo, 300);
            return;
        }

        let videoFromJSON = getVideoFromJSON();
        if (!videoFromJSON) return false;

        // If the video can't be found
        if (videoFromJSON === '404') {
            // TODO display something?
            console.error(new Error('Backend could not find video'));
            return;
        }
        updateVideoPlayer(videoFromJSON);
    }

    /**
     * Adds/updates the actual videoplayer element
     * @param {object} videoData
     */
    function updateVideoPlayer(videoData) {
        if (videoPlayer) {
            // If we already have a player, don't try to create it again
            // Without this, web components hit this twice always
            // Which is kind of a problem for analytics becuase then either
            // have to:
            // - destroy and create a new player
            // - Update the props (which may or may not work,
            //   and may or may not cause weird analytics)
            // Currently, changing the video in place on a video player is
            // not a use case. So leaving it for now.
            return;
        }

        // create the video player
        videoPlayer = new VideoPlayer({
            target: selfWebComponent.parentElement,
            anchor: selfWebComponent,
            props: {
                video: videoData,
                settings,
            },
        });
    }

    /**
     * Attempts to parse the video.
     * @returns {undefined/"404"/object}
     * - undefined if no video
     * - "404" if server says it can't find the video
     * - {videoData} if it succeeded
     */
    function getVideoFromJSON() {
        let videoJSON = video;
        if (!videoJSON) return undefined;
        videoJSON = decodeURI(videoJSON.trim());
        if (videoJSON === '404') return '404';
        return JSON.parse(videoJSON);
    }
</script>
